import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "Sort by": "Sort by",
      "Newest sent first": "Newest sent first",
      "Oldest sent first": "Oldest sent first",
      "Newest reply first": "Newest reply first",
      "Oldest reply first": "Oldest reply first",
      "Last response at": "Last response at",
      "Broadcast footer note":
        "A short signature line with the date and time is added automatically.",
      "Actions apply to": "Actions apply to",
      "selected customers over the selected dates": "selected customers over the selected dates",
      "These actions work on one day at a time": "These actions work on one day at a time",
      "Guide": "Guide",
      "Another action is running": "Another action is running",
      "Each row expands into all of its orders": "Each row expands into all of its orders, so the output can be much larger than the table shows",
      "Customer revenue guide title": "Customer Revenue Report — Guide",
      "Customer revenue guide intro": "This page shows customer revenue day by day. Choose a period and filters, press Filter, then print or export.",
      "Guide steps title": "How to use this page",
      "Guide step 1": "Choose a from-date and a to-date, or tick All to ignore the period.",
      "Guide step 2": "Optionally narrow it down with the company and shipper filters.",
      "Guide step 3": "Press Filter to load the data. Print and export become available afterwards.",
      "Guide disabled title": "Why are the buttons greyed out?",
      "Guide disabled reason 1": "Print and export need data loaded with the same filters you see on screen right now.",
      "Guide disabled reason 2": "Changing a date, a filter or the search box greys them out until you press Filter again.",
      "Guide disabled reason 3": "They are also greyed out while another action is still running.",
      "Guide selection title": "Selecting rows",
      "Guide selection body": "Selection survives paging and is cleared when you press Filter. When rows are selected, Print Details and the exports cover only those rows, and the printed header shows the dates actually printed.",
      "Guide outputs title": "The four outputs",
      "Guide output print": "Print — the summary report across all pages.",
      "Guide output print details": "Print Details — sheets with every order.",
      "Guide output export": "Export — an Excel file of the rows on screen.",
      "Guide output multi export": "Multi Export — one Excel file per customer, aggregated over the period.",
      "Guide warnings title": "Warnings you may see",
      "Guide warning gap": "When the selected days are not consecutive, because the output is labelled as one range.",
      "Guide warning unfiltered": "When no customer or shipper filter is applied.",
      "Guide warning large": "When All is ticked or the period covers more than 10 dates.",
      "Confirm before continuing": "Confirm before continuing",
      "Delete orders": "Delete orders",
      "Delete selected orders confirm": "Delete {{count}} selected order(s)? This cannot be undone.",
      "Delete": "Delete",
      "Continue": "Continue",
      "Cancel": "Cancel",
      "Selected days are not consecutive": "Selected days are not consecutive",
      "You selected": "You selected",
      "No customer or shipper filter is applied": "No customer or shipper filter is applied",
      "This covers": "This covers",
      "dates": "dates",
      "rows": "rows",
      "This may take a while and produce a large document.": "This may take a while and produce a large document.",
      "Click Filter first to load the data": "Click Filter first to load the data",
      "Print the summary report for the rows currently loaded": "Print the summary report for the rows currently loaded",
      "Print the per-order detail sheets": "Print the per-order detail sheets",
      "Download the loaded rows as an Excel file": "Download the loaded rows as an Excel file",
      "Download one Excel file per selected customer": "Download one Excel file per selected customer",
      "selected rows only": "selected rows only",
      "Welcome to React": "Welcome to React and react-i18next",
      "Shipper Performance Report": "Shipper Performance Report",
      "Generate Report": "Generate Report",
      "Has Problem": "Has Problem",
      "Exclude City": "Exclude City",
      "Hold Reasons": "Hold Reasons",
      "Undelivered Reasons": "Undelivered Reasons",
      "Sort by Reason": "Sort by Reason",
      "None": "None",
      "Hold Breakdown": "Hold Breakdown",
      "Undelivered Breakdown": "Undelivered Breakdown",
      "Reason": "Reason",
      "Percentage": "Percentage",
      "Performance Breakdown": "Performance Breakdown",
      "Deliv Target": "Deliv Target",
      "Out": "Out",
      "Shippers Performance": "Shippers Performance",
      "No hold reasons recorded for this period.": "No hold reasons recorded for this period.",
      "No undelivered reasons recorded for this period.": "No undelivered reasons recorded for this period.",
      "No data found. Adjust filters and click \"Generate Report\".": "No data found. Adjust filters and click \"Generate Report\".",
      "Total Shippers Worked": "Total Shippers Worked",
      "Date Range": "Date Range",
      "to": "to",
      "Performance Problem Detected": "Performance Problem Detected",
      "Shipper Name": "Shipper Name",
      "Shipper": "Shipper",
      "Audit Log Report": "Audit Log Report",
      "Audit Log": "Audit Log",
      "Audit Logs": "Audit Logs",
      "Admin Action": "Admin Action",
      "Deleted Orders": "Deleted Orders",
      "Deleted Order Snapshot": "Deleted Order Snapshot",
      "Order Lifecycle & Deletion Audit": "Order Lifecycle & Deletion Audit",
      "Lifecycle Audit Trail (AuditLog)": "Lifecycle Audit Trail (AuditLog)",
      "Field-by-Field Mutations (EntityLog)": "Field-by-Field Mutations (EntityLog)",
      "Serial / Old Serial": "Serial / Old Serial",
      "Serial": "Serial",
      "Phone": "Phone",
      "Phone match": "Phone match",
      "Contains": "Normal",
      "Starts with": "Starts with — Fast",
      "Exact": "Exact — Fastest",
      "Phone search help": "Phone search help",
      "Phone search help title": "Phone search",
      "Phone search help contains": "Normal: use this when you only know part of the number. Without dates, it checks the last 90 days.",
      "Phone search help starts with": "Starts with — Fast: use this when you know how the number begins. It can search older orders.",
      "Shipment Price Templates": "Shipment Price Templates",
      "All cities are already configured": "All cities are already configured",
      "How shipment price templates work": "How shipment price templates work",
      "Shipment price templates help title": "How shipment price templates work",
      "Shipment price templates help intro": "Use this page to create a reusable shipment-price list for a customer category. A template is a simple reference list: each row defines the destination city, the shipper, the total fee charged to the customer, and the shipper fee.",
      "Shipment price templates setup title": "Recommended setup",
      "Shipment price templates setup step 1": "Start with a customer whose shipment prices are already correct, then choose Import to copy those rows as your starting point. You can edit or remove any imported row before saving.",
      "Shipment price templates setup step 2": "Give the template a clear name, then choose the customer category it belongs to. A category can have one shipment-price template, so choose an available category.",
      "Shipment price templates setup step 3": "Add one row for every destination city you need. For each row, select the shipper, enter the total fee charged to the customer, and enter that shipper's fee.",
      "Shipment price templates setup step 4": "Review the cities and amounts, then save. Saving the template itself does not change existing customer price lists.",
      "Shipment price templates pricing example title": "Example: a simple price row",
      "Shipment price templates pricing example": "For a template named Standard Pricing, add a row for Cairo with Shipper A. If the customer pays 80 and the shipper receives 55, enter Total Fees = 80 and Shipper Fees = 55. Repeat this for each city served by the category.",
      "Shipment price templates bulk adjustment title": "When to use Bulk Price Adjustment",
      "Shipment price templates bulk adjustment": "Use the plus icon on a template only when you want to raise every Total Fee in that template by the same fixed amount or percentage. Selecting “Apply to current customers” also updates the shipment prices of existing customers in that template's category. Check the category and increase carefully before saving.",
      "Close": "Close",
      "Phone search help exact": "Exact — Fastest: use this when you have the full number exactly as it was saved. It can search older orders.",
      "Phone search limit": "* Note: Normal phone searches without a date range are limited to orders from the last 90 days.",
      "From Date": "From Date",
      "To Date": "To Date",
      "Apply": "Apply",
      "From Delete Date": "From Delete Date",
      "To Delete Date": "To Delete Date",
      "Deleted At": "Deleted At",
      "Deleted By": "Deleted By",
      "Customer": "Customer",
      "Select customer...": "Select customer...",
      "Select user...": "Select user...",
      "total": "total",
      "Actor / User": "Actor / User",
      "Deleted By User / Actor": "Deleted By User / Actor",
      "Change / Transition": "Change / Transition",
      "Note / Reason": "Note / Reason",
      "Order Created": "Order Created",
      "Order Deleted": "Order Deleted",
      "Order Event": "Order Event",
      "Original Serial": "Original Serial",
      "View Lifecycle & Deletion Audit Trail": "View Lifecycle & Deletion Audit Trail",
      "Field": "Field",
      "Old Value": "Old Value",
      "New Value": "New Value",
      "Field Name": "Field Name",
      "Transaction Date": "Transaction Date",
      "State Date": "State Date",
      "Shipper Performance Permissions": "Shipper Performance Permissions",
      "Select User": "Select User",
      "Shipper ID": "Shipper ID",
      "Phone Number": "Phone Number",
      "Save Changes": "Save Changes",
      "Permissions saved successfully": "Permissions saved successfully",
      "Please select a user first": "Please select a user first",
      "Recipient Delivery Score": "Recipient Delivery Score",
      "Send feedback": "Send feedback",
      "Purpose": "Purpose",
      "Not used": "Not used",
      "No feedback templates yet. Open WhatsApp templates and set a template's Purpose to Feedback.": "No feedback templates yet. Open WhatsApp templates and set a template's Purpose to Feedback.",
      "No active templates. Add one under WhatsApp templates.": "No active templates. Add one under WhatsApp templates.",
      "Hold follow-up": "Hold follow-up",
      "Feedback": "Feedback",
      "Feedback templates are never auto-routed and ignore hold reasons.": "Feedback templates are never auto-routed and ignore hold reasons.",
      "Send feedback to all matching": "Send feedback to all matching",
      "Choose a template": "Choose a template",
      "Every selected order is sent the same feedback template, whatever its hold reason.": "Every selected order is sent the same feedback template, whatever its hold reason.",
      "Every selected order is sent the same template. Orders whose hold reason the template does not cover are skipped — the preview lists them.": "Every selected order is sent the same template. Orders whose hold reason the template does not cover are skipped — the preview lists them.",
      "Based on {{count}} completed order(s) only": "Based on {{count}} completed order(s) only",
      "Could not load the delivery score for this number.": "Could not load the delivery score for this number.",
      "No valid Egyptian mobile number in this order, so no delivery score can be shown.": "No valid Egyptian mobile number in this order, so no delivery score can be shown.",
      "Not a valid Egyptian mobile number, so it has no delivery score.": "Not a valid Egyptian mobile number, so it has no delivery score.",
      "primary": "primary",
      "Total orders": "Total orders",
      "Still in progress": "Still in progress",
      "Cancelled and returned": "Cancelled and returned",
      "Delivery rate": "Delivery rate",
      "Cancellation rate": "Cancellation rate",
      "High delivery rate": "High delivery rate",
      "Average delivery rate": "Average delivery rate",
      "Low delivery rate": "Low delivery rate",
      "Not enough data": "Not enough data",
      "Your orders with this number": "Your orders with this number",
      "delivered": "delivered",
      "total": "total",

      // Namespaced: bare "Delivered" already means the shipment was handed over.
      "wa.status.read": "Read",
      "wa.status.delivered": "Delivered",
      "wa.status.accepted": "Accepted by WhatsApp",
      "wa.status.queued": "Queued",
      "wa.status.sending": "Sending",
      "wa.status.failed": "Failed",
      "wa.status.cancelled": "Cancelled",
      "wa.status.unknown": "Unknown",
      "wa.queued": "Queued",
      "wa.accepted": "Accepted",
      "wa.delivered": "Delivered",
      "wa.failed": "Failed",
      "wa.awaiting": "Awaiting reply",
      "wa.queueDrained": "Queue empty",
      "wa.acceptedAt": "Accepted by WhatsApp at",
      "wa.deliveredAt": "Delivered at",
      "wa.readAt": "Read at",
      "wa.failedAt": "Failed at",
      "wa.alerts.title": "Delivery-failure alerts",
      "wa.alerts.sub": "Emailed when messages WhatsApp accepted are then reported as undelivered.",
      "wa.alerts.emails": "Alert recipients",
      "wa.alerts.emailsHelp": "Comma or newline separated. Leave empty to record failures in the log only.",
      "wa.alerts.threshold": "Failures before alerting",
      "How shipment price templates work": "How shipment price templates work",
      "Shipment price templates help title": "How shipment price templates work",
      "Shipment price templates help intro": "Use this page to create a reusable shipment-price list for a customer category. A template is a simple reference list: each row defines the destination city, the shipper, the total fee charged to the customer, and the shipper fee.",
      "Shipment price templates setup title": "Recommended setup",
      "Shipment price templates setup step 1": "Start with a customer whose shipment prices are already correct, then choose Import to copy those rows as your starting point. You can edit or remove any imported row before saving.",
      "Shipment price templates setup step 2": "Give the template a clear name, then choose the customer category it belongs to. A category can have one shipment-price template, so choose an available category.",
      "Shipment price templates setup step 3": "Add one row for every destination city you need. For each row, select the shipper, enter the total fee charged to the customer, and enter that shipper's fee.",
      "Shipment price templates setup step 4": "Review the cities and amounts, then save. Saving the template itself does not change existing customer price lists.",
      "Shipment price templates pricing example title": "Example: a simple price row",
      "Shipment price templates pricing example": "For a template named Standard Pricing, add a row for Cairo with Shipper A. If the customer pays 80 and the shipper receives 55, enter Total Fees = 80 and Shipper Fees = 55. Repeat this for each city served by the category.",
      "Shipment price templates bulk adjustment title": "When to use Bulk Price Adjustment",
      "Shipment price templates bulk adjustment": "Use the plus icon on a template only when you want to raise every Total Fee in that template by the same fixed amount or percentage. Selecting “Apply to current customers” also updates the shipment prices of existing customers in that template's category. Check the category and increase carefully before saving.",
      "Close": "Close",
      "Phone search help exact": "Exact — Fastest: use this when you have the full number exactly as it was saved. It can search older orders.",
      "Phone search limit": "* Note: Normal phone searches without a date range are limited to orders from the last 90 days.",
      "From Date": "From Date",
      "To Date": "To Date",
      "Apply": "Apply",
      "From Delete Date": "From Delete Date",
      "To Delete Date": "To Delete Date",
      "Deleted At": "Deleted At",
      "Deleted By": "Deleted By",
      "Customer": "Customer",
      "Select customer...": "Select customer...",
      "Select user...": "Select user...",
      "total": "total",
      "Actor / User": "Actor / User",
      "Deleted By User / Actor": "Deleted By User / Actor",
      "Change / Transition": "Change / Transition",
      "Note / Reason": "Note / Reason",
      "Order Created": "Order Created",
      "Order Deleted": "Order Deleted",
      "Order Event": "Order Event",
      "Original Serial": "Original Serial",
      "View Lifecycle & Deletion Audit Trail": "View Lifecycle & Deletion Audit Trail",
      "Field": "Field",
      "Old Value": "Old Value",
      "New Value": "New Value",
      "Field Name": "Field Name",
      "Transaction Date": "Transaction Date",
      "State Date": "State Date",
      "Shipper Performance Permissions": "Shipper Performance Permissions",
      "Select User": "Select User",
      "Shipper ID": "Shipper ID",
      "Phone Number": "Phone Number",
      "Save Changes": "Save Changes",
      "Permissions saved successfully": "Permissions saved successfully",
      "Please select a user first": "Please select a user first",
      "Recipient Delivery Score": "Recipient Delivery Score",
      "Send feedback": "Send feedback",
      "Purpose": "Purpose",
      "Not used": "Not used",
      "No feedback templates yet. Open WhatsApp templates and set a template's Purpose to Feedback.": "No feedback templates yet. Open WhatsApp templates and set a template's Purpose to Feedback.",
      "No active templates. Add one under WhatsApp templates.": "No active templates. Add one under WhatsApp templates.",
      "Hold follow-up": "Hold follow-up",
      "Feedback": "Feedback",
      "Feedback templates are never auto-routed and ignore hold reasons.": "Feedback templates are never auto-routed and ignore hold reasons.",
      "Send feedback to all matching": "Send feedback to all matching",
      "Choose a template": "Choose a template",
      "Every selected order is sent the same feedback template, whatever its hold reason.": "Every selected order is sent the same feedback template, whatever its hold reason.",
      "Every selected order is sent the same template. Orders whose hold reason the template does not cover are skipped — the preview lists them.": "Every selected order is sent the same template. Orders whose hold reason the template does not cover are skipped — the preview lists them.",
      "Based on {{count}} completed order(s) only": "Based on {{count}} completed order(s) only",
      "Could not load the delivery score for this number.": "Could not load the delivery score for this number.",
      "No valid Egyptian mobile number in this order, so no delivery score can be shown.": "No valid Egyptian mobile number in this order, so no delivery score can be shown.",
      "Not a valid Egyptian mobile number, so it has no delivery score.": "Not a valid Egyptian mobile number, so it has no delivery score.",
      "primary": "primary",
      "Total orders": "Total orders",
      "Still in progress": "Still in progress",
      "Cancelled and returned": "Cancelled and returned",
      "Delivery rate": "Delivery rate",
      "Cancellation rate": "Cancellation rate",
      "High delivery rate": "High delivery rate",
      "Average delivery rate": "Average delivery rate",
      "Low delivery rate": "Low delivery rate",
      "Not enough data": "Not enough data",
      "Your orders with this number": "Your orders with this number",
      "delivered": "delivered",
      "total": "total",

      // Namespaced: bare "Delivered" already means the shipment was handed over.
      "wa.status.read": "Read",
      "wa.status.delivered": "Delivered",
      "wa.status.accepted": "Accepted by WhatsApp",
      "wa.status.queued": "Queued",
      "wa.status.sending": "Sending",
      "wa.status.failed": "Failed",
      "wa.status.cancelled": "Cancelled",
      "wa.status.unknown": "Unknown",
      "wa.queued": "Queued",
      "wa.accepted": "Accepted",
      "wa.delivered": "Delivered",
      "wa.failed": "Failed",
      "wa.awaiting": "Awaiting reply",
      "wa.queueDrained": "Queue empty",
      "wa.acceptedAt": "Accepted by WhatsApp at",
      "wa.deliveredAt": "Delivered at",
      "wa.readAt": "Read at",
      "wa.failedAt": "Failed at",
      "wa.alerts.title": "Delivery-failure alerts",
      "wa.alerts.sub": "Emailed when messages WhatsApp accepted are then reported as undelivered.",
      "wa.alerts.emails": "Alert recipients",
      "wa.alerts.emailsHelp": "Comma or newline separated. Leave empty to record failures in the log only.",
      "wa.alerts.threshold": "Failures before alerting",
      "wa.alerts.thresholdHelp": "Counted per 10-minute check.",
      "wa.alerts.cooldown": "Cooldown (minutes)",
      "wa.alerts.cooldownHelp": "Silence after an alert is sent.",
      "wa.alerts.smtpNote": "Requires SMTP configured on the server. Verify with: manage.py check_delivery_alerts",
      "wa.alerts.invalid": "Not a valid email address",
      "Unsaved changes": "Unsaved changes",
      "Scope (Include)": "Scope (Include)",
      "Scope (Exclude)": "Scope (Exclude)",
      "By Scope": "By Scope",
      "By Type": "By Type",
      "Sync shipment price template description": "Sync city prices from {{template}} to existing customers in its category.",
      "Shipment price sync preview": "{{customers}} customer(s): {{missing}} missing city row(s) to create, {{existing}} existing city row(s) available to update.",
      "Shipment price sync cities": "Template cities: {{cities}}",
      "Add missing cities only": "Add missing cities only",
      "Add missing cities and overwrite existing rows": "Add missing cities and overwrite existing rows",
      "Overwrite shipment price sync warning": "This will replace the shipper, fees, and shipment content for existing matching city rows.",
      "I understand the selected shipment price sync mode": "I understand the selected sync mode.",
      "Sync shipment prices": "Sync shipment prices",
      "Sync cities to current customers": "Sync cities to current customers",
      "Fix Duplicates": "Fix Duplicates",
      "Some customers have duplicate shipment-price rows for a template city.": "Some customers have duplicate shipment-price rows for a template city.",
      "Some customers have duplicate shipment-price rows.": "Some customers have duplicate shipment-price rows.",
      "Resolve Duplicate Shipment Prices": "Resolve Duplicate Shipment Prices",
      "Resolve Duplicate Shipment Prices for Template": "Resolve Duplicate Shipment Prices for Template ({{template}})",
      "Resolve Duplicate Shipment Prices for Category": "Resolve Duplicate Shipment Prices for Category ({{category}})",
      "Check & Fix Duplicate Shipment Prices": "Check & Fix Duplicate Shipment Prices",
      "Duplicate shipment prices explanation": "The system keeps the latest modified (or highest ID) row and permanently deletes older duplicate rows with full audit logging.",
      "Duplicate shipment prices summary alert": "Found {{groups}} duplicate group(s) containing {{rows}} row(s) to be removed.",
      "Kept Row Details": "Kept Row Details",
      "Duplicates to Remove": "Duplicates to Remove",
      "I understand that older duplicate rows will be deleted permanently": "I understand that older duplicate rows will be deleted permanently.",
      "No duplicate shipment price rows found": "No duplicate shipment price rows found.",
      "Cleaning Duplicates...": "Cleaning Duplicates...",
      "Clean Duplicates": "Clean Duplicates",
      "Adjusting shipment prices for category": "You are adjusting shipment prices for category {{category}}.",
      "Bulk shipment price adjustment warning": "This will adjust total fees for all existing shipment price rows for customers in this category. It does not change shipper fees or the template used for new customers.",
      "I understand this updates all current customers in this category": "I understand this updates all current customers in this category.",
      "Apply adjustment": "Apply adjustment",
      "Enter a number greater than 0": "Enter a number greater than 0",
      "Increase template prices": "Increase template prices",
      "Increase template prices help": "Changes total fees in this template. You can also optionally apply this adjustment to current customers in the category and sync cities.",
      "Apply price increase to current customers in this category": "Apply price increase to current customers in this category",
      'Type "YES I AGREE" to confirm': 'Type "YES I AGREE" to confirm',
      "Attach a category before applying to customers": "Attach a category before applying to customers",
      "Also sync cities to current customers": "Also sync cities to current customers",
      'Type "YES I AGREE" to confirm': 'Type "YES I AGREE" to confirm',
      "Skipped — Inactive with valid WhatsApp group": "Skipped — Inactive with valid WhatsApp group",
      "Skipped — Inactive without valid WhatsApp group": "Skipped — Inactive without valid WhatsApp group",
      "Skipped — Inactive with no WhatsApp group": "Skipped — Inactive with no WhatsApp group",
      "Skipped — no WhatsApp group": "Skipped — no WhatsApp group",
      "Skipped — invalid WhatsApp group": "Skipped — invalid WhatsApp group",
      "Skipped — inactive customer": "Skipped — inactive customer",
      "Skipped — no longer available": "Skipped — no longer available",
      "Search by ID, name, or WhatsApp group...": "Search by ID, name, or WhatsApp group...",
      "No customers found": "No customers found",
      "Open the full searchable list to review these customers.": "Open the full searchable list to review these customers.",
      "Copy city price to customers": "Copy city price to customers",
      "Copy each current customer's source city price to the new city, then apply the adjustment.": "Copy each current customer's source city price to the new city, then apply the adjustment.",
      "Source city": "Source city",
      "New city": "New city",
      "New shipper": "New shipper",
      "New shipper (optional)": "New shipper (optional)",
      "Shipper assignment (optional)": "Shipper assignment (optional)",
      "Shipper payout": "Shipper payout",
      "New shipper fees": "New shipper fees",
      "Per-run payout amount for the new shipper (defaults to shipper's standard fee).": "Per-run payout amount for the new shipper (defaults to shipper's standard fee).",
      "Leave the shipper empty to keep each source row's shipper and payout.": "Leave the shipper empty to keep each source row's shipper and payout.",
      "Choose a shipper for the new city": "Choose a shipper for the new city",
      "Enter a positive shipper payout amount": "Enter a positive shipper payout amount",
      "Source city and new city must be different": "Source city and new city must be different",
      "Add {{city}} only where missing": "Add {{city}} only where missing",
      "Also replace {{newCity}} price for {{count}} customers with {{sourceCity}} {{adjustment}}": "Also replace {{newCity}} price for {{count}} customers with {{sourceCity}} {{adjustment}}",
      "Price adjustment": "Price adjustment",
      "Current price": "Current price",
      "New price": "New price",
      "Use a positive or negative amount, but not zero.": "Use a positive or negative amount, but not zero.",
      "Choose both source and new cities": "Choose both source and new cities",
      "Enter a non-zero price adjustment": "Enter a non-zero price adjustment",
      "Some customers have duplicate shipment-price rows for the selected cities.": "Some customers have duplicate shipment-price rows for the selected cities.",
      "Customers": "Customers",
      "Will create": "Will create",
      "Will overwrite": "Will overwrite",
      "Skipped — no source city price": "Skipped — no source city price",
      "Skipped — city already exists": "Skipped — city already exists",
      "Review changes": "Review changes",
      "Refresh preview": "Refresh preview",
      "No customer prices will change": "No customer prices will change",
      "Apply to {{count}} customers": "Apply to {{count}} customers",
      "View customer details ({{count}})": "View customer details ({{count}})",
      "Skipped": "Skipped",
      "Customer price review": "Customer price review",
      "All": "All",
      "Search by ID or customer name": "Search by ID or customer name",
      "Search by company name": "Search by company name",
      "Outcome": "Outcome",
      "Check & Fix Duplicate Prices": "Check & Fix Duplicate Prices",
      "Resolve Duplicate Prices for Category": "Resolve Duplicate Prices for Category ({{category}})",
      "Shipment prices": "Shipment prices",
      "Return prices": "Return prices",
      "Duplicate return prices explanation": "A return price is duplicated when the same customer, return status and city appear in more than one row. The system keeps the latest modified (or highest ID) row, removes the city from the older rows, and deletes rows left without cities, with full audit logging.",
      "Duplicate return prices summary alert": "Found {{groups}} duplicate group(s): the city will be removed from {{rows}} older row(s), and {{deleted}} row(s) left without cities will be deleted.",
      "Return status": "Return status",
      "Removed fees": "Removed fees",
      "I understand that the city will be removed from older duplicate return-price rows": "I understand that the city will be removed from older duplicate return-price rows",
      "No duplicate return price rows found": "No duplicate return price rows found",
      "Some customers have duplicate return-price rows for the selected cities.": "Some customers have duplicate return-price rows for the selected cities.",
      "Add to existing row": "Add to existing row",
      "return_city_copy_description": "Add the new city to customers' return prices without changing any fee. With a source city it joins every row that holds the source city; without one it joins the newest row of each status. Statuses that already cover the new city are skipped.",
      "Source city (optional)": "Source city (optional)",
      "{{newCity}} is added to {{rows}}, fees unchanged": "{{newCity}} is added to {{rows}}, fees unchanged",
      "rows holding {{city}}": "rows holding {{city}}",
      "the newest row of each status": "the newest row of each status",
      "Skipped — no return prices": "Skipped — no return prices",
      "Row that gets the city": "Row that gets the city",
      "Apply to {{count}} return prices": "Apply to {{count}} return prices",
      "Active rules run daily and permanently delete every matching order older than the set number of days. Orders with financial records, or that were collected or returned, are skipped. Material request orders are never deleted.": "Active rules run daily and permanently delete every matching order older than the set number of days. Orders with financial records, or that were collected or returned, are skipped. Material request orders are never deleted.",
      "Always protected": "Always protected",
      "Always protected: these orders are in a shipper's cash hand-over that is still pending, or have a material request (deleting the order would delete it).": "Always protected: these orders are in a shipper's cash hand-over that is still pending, or have a material request (deleting the order would delete it).",
      "Collected (customer)": "Collected (customer)",
      "Collected by shipper": "Collected by shipper",
      "Completed": "Completed",
      "Counting matching orders, this can take a while…": "Counting matching orders, this can take a while…",
      "Customer revenue": "Customer revenue",
      "Deleted": "Deleted",
      "Deleted by cleanup run #{{id}}": "Deleted by cleanup run #{{id}}",
      "Disable protection": "Disable protection",
      "Discard": "Discard",
      "Enable": "Enable",
      "Enable cleanup rule": "Enable cleanup rule",
      "Error": "Error",
      "Failed": "Failed",
      "Financial records": "Financial records",
      "Finished": "Finished",
      "Hide protections": "Hide protections",
      "Interrupted": "Interrupted",
      "Label": "Label",
      "Last run": "Last run",
      "Matched": "Matched",
      "Matching orders will be permanently deleted every day. This cannot be undone.": "Matching orders will be permanently deleted every day. This cannot be undone.",
      "Material request": "Material request",
      "Never run": "Never run",
      "Nothing matches today; future matches will be deleted daily.": "Nothing matches today; future matches will be deleted daily.",
      "Older than (days)": "Older than (days)",
      "Older than (days) must be at least 1": "Older than (days) must be at least 1",
      "Order Cleanup Rules": "Order Cleanup Rules",
      "Pending closing request": "Pending closing request",
      "Protected — read only ({{skipped_count}})": "Protected — read only ({{skipped_count}})",
      "Protections": "Protections",
      "Protections disabled": "Protections disabled",
      "Protections off": "Protections off",
      "Reasons": "Reasons",
      "Retry": "Retry",
      "Return requests": "Return requests",
      "Returned by shipper": "Returned by shipper",
      "Returned to client": "Returned to client",
      "Rule {{name}} has not run in over {{hours}} hours; the daily job may not be running.": "Rule {{name}} has not run in over {{hours}} hours; the daily job may not be running.",
      "Rule {{name}} is active with protections disabled: {{labels}}": "Rule {{name}} is active with protections disabled: {{labels}}",
      "Rule {{name}} last run {{status}}: {{error}}": "Rule {{name}} last run {{status}}: {{error}}",
      "Rule {{name}} was skipped: {{reason}}": "Rule {{name}} was skipped: {{reason}}",
      "Run history": "Run history",
      "Running": "Running",
      "Save changes before enabling": "Save changes before enabling",
      "Preview changes": "Preview changes",
      "Preview of your unsaved changes. Nothing is saved; save the rule to use them.": "Preview of your unsaved changes. Nothing is saved; save the rule to use them.",
      "Saved": "Saved",
      "Set and save a filter before changing protections": "Set and save a filter before changing protections",
      "Shipper revenue": "Shipper revenue",
      "Started": "Started",
      "Status flags": "Status flags",
      "Stopped": "Stopped",
      "View deleted orders": "View deleted orders",
      "Will be deleted ({{count}})": "Will be deleted ({{count}})",
      "You do not have access to this page.": "You do not have access to this page.",
      "protects {{count}} matched orders": "protects {{count}} matched orders",
      "protects {{count}} matched orders ({{uncovered}} not covered by status flags)": "protects {{count}} matched orders ({{uncovered}} not covered by status flags)",
      "{{count}} audit log rows failed to write": "{{count}} audit log rows failed to write",
      "{{count}} orders will become deletable even though they are marked {{label}}. Deleted orders cannot be restored.": "{{count}} orders will become deletable even though they are marked {{label}}. Deleted orders cannot be restored.",
      "{{count}} orders will become deletable. Their related {{label}} records are deleted with them and cannot be restored.": "{{count}} orders will become deletable. Their related {{label}} records are deleted with them and cannot be restored.",
      "{{label}} protects {{count}} matched orders.": "{{label}} protects {{count}} matched orders.",
      "Address": "Address",
      "Copy": "Copy",
      "Copied": "Copied",
      "Details": "Details",
      "Follow-up user": "Follow-up user",
      "Order Month Export": "Order Month Export",
      "Exports every order of the chosen month, with no row limit. Files are deleted after 7 days.": "Exports every order of the chosen month, with no row limit. Files are deleted after 7 days.",
      "Month": "Month",
      "Year": "Year",
      "Status": "Status",
      "Done": "Done",
      "Requested by": "Requested by",
      "Requested at": "Requested at",
      "Finished at": "Finished at",
      "No exports yet": "No exports yet",
      "Export started, it will appear here when ready": "Export started, it will appear here when ready",
      "Failed to load exports": "Failed to load exports",
      "Failed to start export": "Failed to start export",
      "Failed to delete export": "Failed to delete export",
      "Failed to download export": "Failed to download export",
      "Saving file…": "Saving file…",
    },
  },
  ar: {
    translation: {
      "Sort by": "الترتيب حسب",
      "Newest sent first": "الأحدث إرسالاً أولاً",
      "Oldest sent first": "الأقدم إرسالاً أولاً",
      "Newest reply first": "أحدث رد أولاً",
      "Oldest reply first": "أقدم رد أولاً",
      "Last response at": "آخر رد في",
      "Actions apply to": "الإجراءات هتتطبق على",
      "selected customers over the selected dates": "العملاء المحددين خلال التواريخ المحددة",
      "These actions work on one day at a time": "الإجراءات دي بتشتغل على يوم واحد بس",
      "Guide": "دليل الاستخدام",
      "Another action is running": "فيه إجراء تاني شغال دلوقتي",
      "Each row expands into all of its orders": "كل صف بيتفتح على كل أوردراته، فالمخرجات ممكن تكون أكبر بكتير من اللي ظاهر في الجدول",
      "Customer revenue guide title": "دليل تقرير إيرادات العملاء",
      "Customer revenue guide intro": "الصفحة دي بتعرض إيرادات العملاء يوم بيوم. اختار الفترة والفلاتر، اضغط فلتر، وبعدين اطبع أو صدّر.",
      "Guide steps title": "طريقة الاستخدام",
      "Guide step 1": "اختار تاريخ البداية والنهاية، أو فعّل خيار الكل لتجاهل الفترة.",
      "Guide step 2": "لو عايز، اختار شركة أو أكتر ومندوب من الفلاتر.",
      "Guide step 3": "اضغط زر فلتر لتحميل البيانات، وبعدها الطباعة والتصدير هيبقوا متاحين.",
      "Guide disabled title": "ليه الأزرار مقفولة؟",
      "Guide disabled reason 1": "أزرار الطباعة والتصدير محتاجة بيانات محمّلة بنفس الفلاتر الظاهرة قدامك.",
      "Guide disabled reason 2": "أي تعديل في التاريخ أو الفلاتر أو البحث بيقفل الأزرار لحد ما تضغط فلتر تاني.",
      "Guide disabled reason 3": "الأزرار بتتقفل كمان طول ما فيه إجراء تاني شغال.",
      "Guide selection title": "تحديد الصفوف",
      "Guide selection body": "التحديد بيفضل موجود لما تنتقل بين الصفحات، وبيتلغي لما تضغط فلتر. ولما تحدد صفوف، طباعة التفاصيل والتصدير بيشتغلوا على المحدد بس، وعنوان الطباعة بيعرض التواريخ المطبوعة فعلاً.",
      "Guide outputs title": "الفرق بين المخرجات",
      "Guide output print": "طباعة: تقرير مجمّع لكل الصفحات.",
      "Guide output print details": "طباعة التفاصيل: كشوف بتفاصيل كل أوردر.",
      "Guide output export": "تصدير: ملف Excel بالصفوف المعروضة.",
      "Guide output multi export": "تصدير متعدد: ملف Excel لكل عميل، مجمّع على مدى الفترة.",
      "Guide warnings title": "التنبيهات اللي ممكن تظهرلك",
      "Guide warning gap": "لما تختار أيام مش متتالية، لأن المخرجات بتتسمّى كمدى واحد.",
      "Guide warning unfiltered": "لما مايكونش فيه فلتر عميل أو مندوب.",
      "Guide warning large": "لما تفعّل خيار الكل أو الفترة تزيد عن ١٠ تواريخ.",
      "Confirm before continuing": "تأكيد قبل المتابعة",
      "Delete orders": "حذف الطلبات",
      "Delete selected orders confirm": "حذف {{count}} طلب محدد؟ لا يمكن التراجع عن هذا.",
      "Continue": "متابعة",
      "Selected days are not consecutive": "الأيام المختارة غير متتالية",
      "You selected": "اخترت",
      "No customer or shipper filter is applied": "لا يوجد فلتر عميل أو مندوب",
      "This covers": "التقرير يغطي",
      "dates": "يوم",
      "rows": "صف",
      "This may take a while and produce a large document.": "ممكن ياخد وقت وينتج مستند كبير.",
      "Click Filter first to load the data": "اضغط فلتر الأول علشان البيانات تتحمّل",
      "Print the summary report for the rows currently loaded": "طباعة التقرير المجمّع للصفوف المعروضة",
      "Print the per-order detail sheets": "طباعة كشوف تفاصيل الطلبات",
      "Download the loaded rows as an Excel file": "تنزيل الصفوف المعروضة كملف Excel",
      "Download one Excel file per selected customer": "تنزيل ملف Excel لكل عميل محدد",
      "selected rows only": "الصفوف المحددة فقط",
      "Skipped — Inactive with valid WhatsApp group": "تم التخطي — غير نشط (لديه مجموعة واتساب صالحة)",
      "Skipped — Inactive without valid WhatsApp group": "تم التخطي — غير نشط (بدون مجموعة واتساب صالحة)",
      "Skipped — Inactive with no WhatsApp group": "تم التخطي — غير نشط (بدون مجموعة واتساب)",
      "Skipped — no WhatsApp group": "تم التخطي — بدون مجموعة واتساب",
      "Skipped — invalid WhatsApp group": "تم التخطي — مجموعة واتساب غير صالحة",
      "Skipped — inactive customer": "تم التخطي — عميل غير نشط",
      "Skipped — no longer available": "تم التخطي — لم يعد متاحًا",
      "Search by ID, name, or WhatsApp group...": "البحث بالرقم التعريفي، الاسم، أو مجموعة الواتساب...",
      "No customers found": "لم يتم العثور على أي عملاء",
      "Open the full searchable list to review these customers.": "افتح القائمة الكاملة القابلة للبحث لمراجعة هؤلاء العملاء.",
      "Copy city price to customers": "نسخ سعر مدينة للعملاء",
      "Copy each current customer's source city price to the new city, then apply the adjustment.": "انسخ سعر مدينة المصدر لكل عميل إلى المدينة الجديدة، ثم طبق التعديل.",
      "Source city": "مدينة المصدر",
      "New city": "المدينة الجديدة",
      "New shipper": "المندوب الجديد",
      "New shipper (optional)": "المندوب الجديد (اختياري)",
      "Shipper assignment (optional)": "تعيين المندوب (اختياري)",
      "Shipper payout": "أجر المندوب",
      "New shipper fees": "أجر المندوب الجديد",
      "Per-run payout amount for the new shipper (defaults to shipper's standard fee).": "مبلغ أجر المندوب لهذه العملية (يُملأ تلقائيًا بأجر المندوب الافتراضي).",
      "Leave the shipper empty to keep each source row's shipper and payout.": "اترك المندوب فارغاً للحفاظ على مندوب وأجر كل صف في مدينة المصدر.",
      "Choose a shipper for the new city": "اختر مندوبًا للمدينة الجديدة",
      "Enter a positive shipper payout amount": "أدخل مبلغ أجر موجب للمندوب",
      "Source city and new city must be different": "يجب أن تكون مدينة المصدر مختلفة عن المدينة الجديدة",
      "Add {{city}} only where missing": "أضف {{city}} فقط للعملاء الذين لا يملكونها",
      "Also replace {{newCity}} price for {{count}} customers with {{sourceCity}} {{adjustment}}": "استبدل أيضًا سعر {{newCity}} لـ {{count}} عميلًا بسعر {{sourceCity}} {{adjustment}}",
      "Price adjustment": "تعديل السعر",
      "Current price": "السعر الحالي",
      "New price": "السعر الجديد",
      "Use a positive or negative amount, but not zero.": "استخدم مبلغًا موجبًا أو سالبًا، وليس صفرًا.",
      "Choose both source and new cities": "اختر مدينة المصدر والمدينة الجديدة",
      "Enter a non-zero price adjustment": "أدخل تعديل سعر غير صفري",
      "Some customers have duplicate shipment-price rows for the selected cities.": "يوجد لبعض العملاء صفوف أسعار شحن مكررة للمدن المحددة.",
      "Customers": "العملاء",
      "Will create": "سيتم الإنشاء",
      "Will overwrite": "سيتم الاستبدال",
      "Skipped — no source city price": "تم التخطي — لا يوجد سعر لمدينة المصدر",
      "Skipped — city already exists": "تم التخطي — المدينة موجودة بالفعل",
      "Review changes": "مراجعة التغييرات",
      "Refresh preview": "تحديث المعاينة",
      "No customer prices will change": "لن تتغير أسعار أي عميل",
      "Apply to {{count}} customers": "تطبيق على {{count}} عميل",
      "View customer details ({{count}})": "عرض تفاصيل العملاء ({{count}})",
      "Skipped": "تم التخطي",
      "Customer price review": "مراجعة أسعار العملاء",
      "All": "الكل",
      "Search by ID or customer name": "البحث بالرقم أو اسم العميل",
      "Search by company name": "البحث باسم الشركة",
      "Outcome": "النتيجة",
      "All cities are already configured": "تم إعداد أسعار جميع المدن بالفعل",
      "Scope (Include)": "نطاق الرسالة (تضمين)",
      "Scope (Exclude)": "استبعاد نطاق الرسالة",
      "By Scope": "حسب النطاق",
      "By Type": "حسب النوع",
      "Sync shipment price template description": "مزامنة أسعار المدن من {{template}} مع العملاء الحاليين في فئته.",
      "Shipment price sync preview": "{{customers}} عميل: {{missing}} صفوف مدن سيتم إضافتها، و{{existing}} صفوف مدن موجودة قابلة للتحديث.",
      "Shipment price sync cities": "مدن القالب: {{cities}}",
      "Add missing cities only": "إضافة المدن المفقودة فقط",
      "Add missing cities and overwrite existing rows": "إضافة المدن المفقودة واستبدال الصفوف الموجودة",
      "Overwrite shipment price sync warning": "سيؤدي ذلك إلى استبدال المندوب والرسوم ومحتوى الشحنة للصفوف الموجودة للمدينة المطابقة.",
      "I understand the selected shipment price sync mode": "أفهم وضع المزامنة الذي اخترته.",
      "Sync shipment prices": "مزامنة أسعار الشحن",
      "Sync cities to current customers": "مزامنة المدن مع العملاء الحاليين",
      "Fix Duplicates": "معالجة التكرارات",
      "Some customers have duplicate shipment-price rows for a template city.": "يوجد لبعض العملاء صفوف أسعار شحن مكررة لمدينة في القالب.",
      "Some customers have duplicate shipment-price rows.": "يوجد لبعض العملاء صفوف أسعار شحن مكررة.",
      "Resolve Duplicate Shipment Prices": "معالجة صفوف أسعار الشحن المكررة",
      "Resolve Duplicate Shipment Prices for Template": "معالجة أسعار الشحن المكررة للقالب ({{template}})",
      "Resolve Duplicate Shipment Prices for Category": "معالجة أسعار الشحن المكررة للفئة ({{category}})",
      "Check & Fix Duplicate Shipment Prices": "فحص ومعالجة أسعار الشحن المكررة",
      "Duplicate shipment prices explanation": "يقوم النظام بالاحتفاظ بأحدث صف تم تعديله (أو أعلى معرف) وحذف الصفوف القديمة المكررة نهائيًا مع تسجيل كل عملية حذف في سجلات التدقيق.",
      "Duplicate shipment prices summary alert": "تم العثور على {{groups}} مجموعة مكررة تتضمن {{rows}} صفًا سيتم حذفها.",
      "Kept Row Details": "تفاصيل الصف المحتفظ به",
      "Duplicates to Remove": "الصفوف المكررة للحذف",
      "I understand that older duplicate rows will be deleted permanently": "أفهم أنه سيتم حذف الصفوف القديمة المكررة بشكل نهائي.",
      "No duplicate shipment price rows found": "لم يتم العثور على أي صفوف أسعار شحن مكررة.",
      "Cleaning Duplicates...": "جاري معالجة التكرارات...",
      "Clean Duplicates": "حذف الصفوف المكررة",
      "Adjusting shipment prices for category": "أنت تعدل أسعار الشحن لفئة {{category}}.",
      "Bulk shipment price adjustment warning": "سيؤدي ذلك إلى تعديل إجمالي الرسوم لكل صف أسعار شحن للعملاء الحاليين في هذه الفئة. لن يغير رسوم المندوب أو القالب المستخدم للعملاء الجدد.",
      "I understand this updates all current customers in this category": "أفهم أن هذا يعدل جميع العملاء الحاليين في هذه الفئة.",
      "Apply adjustment": "تطبيق التعديل",
      "Enter a number greater than 0": "أدخل رقمًا أكبر من صفر",
      "Increase template prices": "زيادة أسعار القالب",
      "Increase template prices help": "يغير هذا إجمالي الرسوم في هذا القالب. يمكنك أيضًا اختياريًا تطبيق التعديل على العملاء الحاليين في الفئة ومزامنة المدن.",
      "Apply price increase to current customers in this category": "تطبيق زيادة الأسعار على العملاء الحاليين في هذه الفئة",
      "Attach a category before applying to customers": "اربط القالب بفئة قبل التطبيق على العملاء",
      'Type "YES I AGREE" to confirm': 'اكتب "YES I AGREE" للتأكيد',
      "Also sync cities to current customers": "مزامنة المدن أيضًا مع العملاء الحاليين",
      'Type "YES I AGREE" to confirm': 'اكتب "YES I AGREE" للتأكيد',
      "Hold reason doesn't match": "سبب التعليق مش مطابق",
      "Audit Log Report": "تقرير سجل المراجعة",
      "Audit Log": "سجل المراجعة",
      "Audit Logs": "سجلات المراجعة",
      "Shipper": "المندوب",
      "Admin Action": "إجراءات المسؤول",
      "Deleted Orders": "الطلبات المحذوفة",
      "Deleted Order Snapshot": "تفاصيل الطلب المحذوف",
      "Order Lifecycle & Deletion Audit": "سجل دورة حياة وحذف الطلب",
      "Lifecycle Audit Trail (AuditLog)": "سجل دورة الحياة والتعديلات",
      "Field-by-Field Mutations (EntityLog)": "تغييرات الحقول الفردية",
      "Serial / Old Serial": "رقم المسلسل / المسلسل القديم",
      "Serial": "المسلسل",
      "Phone": "الهاتف",
      "Phone match": "طريقة البحث بالهاتف",
      "Contains": "عادي",
      "Starts with": "يبدأ بـ — سريع",
      "Exact": "مطابق تمامًا — الأسرع",
      "Phone search help": "مساعدة البحث بالهاتف",
      "Phone search help title": "البحث بالهاتف",
      "Phone search help contains": "عادي: استخدمه إذا كنت تعرف جزءًا من الرقم فقط. بدون تاريخ، يبحث في آخر 90 يومًا.",
      "Phone search help starts with": "يبدأ بـ — سريع: استخدمه إذا كنت تعرف بداية الرقم. يمكنه البحث في الطلبات الأقدم.",
      "Shipment Price Templates": "قوالب أسعار الشحن",
      "How shipment price templates work": "كيفية عمل قوالب أسعار الشحن",
      "Shipment price templates help title": "كيفية عمل قوالب أسعار الشحن",
      "Shipment price templates help intro": "استخدم هذه الصفحة لإنشاء قائمة أسعار شحن يمكن إعادة استخدامها لفئة من العملاء. القالب هو قائمة مرجعية بسيطة: يحدد كل صف مدينة الوصول والمندوب وإجمالي الرسوم على العميل ورسوم المندوب.",
      "Shipment price templates setup title": "الطريقة المقترحة للإعداد",
      "Shipment price templates setup step 1": "ابدأ بعميل أسعاره الحالية صحيحة، ثم اختر استيراد لنسخ صفوف أسعاره كنقطة بداية. يمكنك تعديل أو حذف أي صف تم استيراده قبل الحفظ.",
      "Shipment price templates setup step 2": "اكتب اسمًا واضحًا للقالب، ثم اختر فئة العملاء التابعة له. لكل فئة قالب أسعار شحن واحد، لذلك اختر فئة متاحة.",
      "Shipment price templates setup step 3": "أضف صفًا لكل مدينة وصول تحتاج إليها. في كل صف اختر المندوب، وأدخل إجمالي الرسوم على العميل، ثم أدخل رسوم هذا المندوب.",
      "Shipment price templates setup step 4": "راجع المدن والمبالغ ثم احفظ. حفظ القالب وحده لا يغير قوائم أسعار العملاء الحاليين.",
      "Shipment price templates pricing example title": "مثال: صف سعر بسيط",
      "Shipment price templates pricing example": "لقالب باسم أسعار Standard، أضف صفًا للقاهرة مع المندوب A. إذا كان العميل يدفع 80 والمندوب يحصل على 55، أدخل إجمالي الرسوم = 80 ورسوم المندوب = 55. كرر ذلك لكل مدينة تخدمها الفئة.",
      "Shipment price templates bulk adjustment title": "متى تستخدم التعديل الجماعي للأسعار",
      "Shipment price templates bulk adjustment": "استخدم علامة الجمع في القالب فقط عندما تريد زيادة كل إجمالي رسوم فيه بالقيمة نفسها أو بالنسبة المئوية نفسها. اختيار تطبيق على العملاء الحاليين يحدّث أيضًا أسعار الشحن للعملاء الحاليين في فئة هذا القالب. راجع الفئة والزيادة جيدًا قبل الحفظ.",
      "Phone search help exact": "مطابق تمامًا — الأسرع: استخدمه إذا كان معك الرقم كاملًا كما هو محفوظ. يمكنه البحث في الطلبات الأقدم.",
      "Phone search limit": "* ملاحظة: البحث العادي بالهاتف بدون نطاق تاريخ يقتصر على الطلبات خلال آخر 90 يومًا.",
      "Apply": "تطبيق",
      "From Delete Date": "من تاريخ الحذف",
      "To Delete Date": "إلى تاريخ الحذف",
      "Deleted At": "تاريخ الحذف",
      "Deleted By": "حذف بواسطة",
      "Deleted By User": "تم الحذف بواسطة المستخدم",
      "Customer": "العميل",
      "Select customer...": "اختر العميل...",
      "Select user...": "اختر المستخدم...",
      "total": "إجمالي",
      "Actor / User": "المستخدم / الفاعل",
      "Deleted By User / Actor": "تم الحذف بواسطة المستخدم",
      "Change / Transition": "التغيير / الانتقال",
      "Note / Reason": "الملاحظات / السبب",
      "Order Created": "تم إنشاء الطلب",
      "Order Deleted": "تم حذف الطلب",
      "Order Event": "حدث الطلب",
      "Original Serial": "المسلسل الأصلي",
      "View Lifecycle & Deletion Audit Trail": "عرض سجل دورة حياة وحذف الطلب",
      "Field": "الحقل",
      "Old Value": "القيمة القديمة",
      "New Value": "القيمة الجديدة",
      "Field Name": "اسم الحقل",
      "Companies With Return Report": "الشركات مع تقرير العائد",
      "Customer Serial": "مسلسل العميل",
      "Reference Id": "معرف مرجعي",
      "Search Name": " البحث بالاسم ",
      "Search Phone": " البحث بالرقم",
      "Search Serial": " البحث بالمسلسل",
      "Order List": "قائمه الاوردرات",
      Import: "استيراد",
      Export: "تصدير",
      "Exporting...": "جاري التصدير...",
      "Download Template": "تحميل النموذج",
      Collect: "نحصيل",
      search: "بحث",
      "Select Month": "اختيار الشهر",
      Wallet: "المحفظه",
      "New Order": "اوردر جديد",
      "Request Material": "طلب مواد",
      "Request Collect": "طلب تحصيل",
      "Status Date": "تاريخ الحاله",
      "Ready To Return": "مرتجعات جاهزة للطلب",
      Revenue: "الربح",
      "Order Status": "حاله الاوردرات",
      "Top Cities": "اعلي المحافظات",
      "Yesterday Orders": "اوردرات اليوم السابق",
      Pending: "تحت المراجعه",
      "Out For Deliver": "خارج للتوصيل",
      Deliverd: "تم التوصيل",
      Hold: "معلق",
      Undelivered: "لم يتم التوصيل",
      Undeliverd: "لم يتم التوصيل",
      Rejected: "مرفوض",
      Serial: "مسلسل",
      "Order Date": "تاريخ الطلب",
      Name: "الاسم",
      Address: "العنوان",
      Phone: "موبايل",
      "Shipment Contents": "محتوي الشحنه",
      "Shipment Content": "محتوي الشحنه",
      'Status': "الحاله",
      "Status Note": "ملاحظات الحاله",
      Return: "مرتجع",
      Collected: "تم التحصيل",
      Weigth: "الوزن",
      Total: "الاجمالي",
      "Total Fees": "اجمالي الرسوم",
      "total Fees": "اجمالي الرسوم",
      "total fees": "اجمالي الرسوم",
      Note: "ملاحظات",
      "From Date": "من تاريخ",
      "To Date": "الي تاريخ",
      "Search Order": "بحث",
      City: "مدينه",
      "Rejected Order List": "قائمه الطلبات المرفوضه",
      Analytics: "تحليلات",
      "Full Name": "الاسم",
      "Shippment Content": "محتوي الشحنه",
      "Total Amount": "اجمالي القيمه",
      Notes: "ملاحظات",
      Download: "تحميل",
      "Client Name": "اسم العميل",
      "Total Shipments": "اجمالي الشحنات",
      Day: "اليوم",
      Details: "تفاصيل",
      All: "الكل",
      Refresh: "تحديث",
      Print: "طباعه",
      "Material Request": "طلب مواد",
      Date: "التاريخ",
      "Collect Request": "طلب تحصيل",
      "Customer Price List": "قائمه اسعار العميل",
      "Todays Order": "اوردرات اليوم",
      "Create a new Order": "انشاء طلب جديد",
      "Create Order": "انشاء طلب",
      Orders: "الاوردرات",
      List: "القائمه",
      Create: "انشاء",
      "Print Orders": "طباعه الاوردرات",
      "Rejected Orders": "قائمه الاوردرات المرفوضه",
      Revenus: "الارباح",
      "Client Price List": "قائمه اسعار العميل",
      "Customer Issue": "مشاكل العميل",
      "Request Pickup": "طلب استلام الشحنات",
      "Pickup Request": "طلب استلام الشحنات",
      Dashboard: "القائمه الرئيسيه",
      Management: "اداره النظام",
      "Customer Revenue Report": "تقرير التحصيلات",
      Pickup: "شحنه",
      "No Pickup Today": "يوجد شحنات اليوم",
      "View Order": "عرض الاوردرات",
      "view order": "عرض الاوردرات",
      "Follow Status": "عرض الاوردرات",
      "Shipper Status Follow Up": "متابعه حالات المندوب",
      "Shipper Revenue": "تحصيلات المندوب",
      // 'No Pickup Today':'يوجد شحنات اليوم',
      "There Exist Pickup Today": "يوجد شحنات اليوم",
      "There is Pickup": "يوجد شحنات اليوم",
      "There is Collect Today": "يوجد تحصيل اليوم",
      "No Collect Today": "لا يوجد تحصيل اليوم",

      Add: "اضافه",
      "Copy From Another Client": "نسخ من عميل أخر",
      "Customer Name": "اسم العميل",
      "Company Name": "اسم العميل",
      Delete: "حذف",
      Shipper: "المندوب",
      Actions: "الوظائف",
      "Set Period": "تعديل الفتره",
      "Unclosed Customers Issues": "شكاوي غير مغلقه",
      "Order Delivery Status": "حالات توصيل الاوردرات",
      "Top Companies Orders": "اكثر الشركات اوردرات",
      "Less Companies Orders": "اقل الشركات اوردرات",
      "Top Clients Orders": "اكثر الشركات اوردرات",
      "Less Clients Orders": "اقل الشركات اوردرات",
      "Top Shippers Orders": "اكثر المندوبين اوردرات",
      "Show More": "رؤيه المزيد",
      "Less Shippers Orders": "اقل المندوبين اوردرات",
      "Today Out For Deliver Orders": "خارج للتوصيل اليوم",
      "Company Credit": "دائن الشركه",
      "Company Debit": "مدين الشركه",
      "Top Shippers Evaluation": "أعلى المندوبين تقييما",
      "Less Shippers Evaluation": "أقل المندوبين تقييما",
      "Money With Shippers [Uncollected Shipper]":
        "نقود مع المندوبين [غير محصله من المندوب]",
      "Customers Money [Uncollected Client]":
        "نقود العملاء [غير محصله من العميل]",
      "CC & Uncollected Shipper": "محصله من العميل ولم تحصل من المندوب",
      "Uncollected Client & Collected Shipper":
        "غير محصله من العميل ومحصله من المندوب",
      "Uncollected Client & Uncollected Shipper":
        "غير محصله من العميل و غير محصله من المندوب",
      Rated: "مقيم",
      Rating: "تقييم",
      From: "من",
      Users: "المستخدمين",
      User: "مستخدم",
      EGP: "ج.م",
      "Orders by City": "أكثر المدن أوردرات",
      "See All": "مشاهدة الكل",
      "Reset Password": "تغيير الباسورد",
      Logout: "تسجيل الخروج",
      Notifications: "أشعارات",
      "There are no notifications": "لايوجد أشعارات",
      "Mark all as read": "قراءة الكل",
      "There are no alerts": "لايوجد تذكيرات اوردرات",
      "Repeated Orders": "أوردرات متكرره",
      "Order Alerts": "تذكيرات اوردرات",
      "Order Alert": "تذكير اوردر",
      "Order alert": "تذكير اوردر",
      "order alert": "تذكير اوردر",
      "There are no Repeated Orders": "لايوجد اوردرات مكرره",
      Repeated: "متكرر",
      Show: "عرض",
      "Database Backup List": "قاعده البيانات (النسخ الاحتياطيه)",
      Operation: "اداره العمليات",
      Customers: "العملاء",
      Edit: "تعديل",
      New: "جديد",
      Shippers: "المندوبين",
      "All Orders": "جميع الاوردرات",
      "Hub Orders": "اوردرات المجمع",
      "Shipment Request": "طلبات الشحن",
      "Follow UP Orders": "متابعه الاوردرات",
      "Shipper Orders Review": "مراجعة اوردرات المندوب",
      "Speed Up": "الاستعجالات",
      Transactions: "الحركات",
      "Shipper Closing": "محاسبه المندوب",
      View: "عرض",
      "Edit Approval": "الموافقه علي التعديلات",
      "Customer Edit Approval": "الموافقه علي تعديلات الشركات",
      "Shipper Edit Approval": "الموافقه علي تعديلات المندوب",
      Issue: "شكوى",
      "Collect Request List": "قائمه طلبات التحصيل",
      "Material Request List": "قائمه طلب المواد",
      "SMS Hold Orders": "مراسله الاوردرات المعلقه",
      "User Evaluation": "تقييم المستخدمين",
      Reports: "تقارير",
      "Shipper Evaluations": "تقييم المندوب",
      "Shipper Evaluation Details": "تفاصيل تقييم المندوب",
      Summary: "ملخص",
      "User Evaluations": "تقييمات المستخدم",
      "User Evaluation Details": "تفاصيل تقييمات المستخدم",
      "Issue Report": "تقرير الشكاوي",
      "Orders Statistics": "احصائيات الاوردرات",
      "Top Companies By Order": "اعلي الشركات اوردرات",
      "Companies Orders by Shipper": "اوردرات الشركات مجمعه بالمندوب",
      "Companies Orders by City": "اوردرات الشركات مجمعه بالمدينة",
      "Cancelled Orders": "الاوردرات المرفوضه",
      "Follow UP Orders Report": "تقرير متابعه الاوردرات",
      "Shipper Tracking": "تتبع المندوب",
      "SMS Report": "تقرير الرسائل",
      "Shipper Transfer Report": "تقرير تحويلات المندوب",
      "Expenses Report": "تقرير المصاريف",
      "Shipper Custody Report": "تقرير عهده المندوب",
      "Shipper Closing Request Report": "تقرير طلبات محاسبه المندوب",
      Settings: "الاعدادات",
      Zone: "المنطقه",
      Area: "المساحه",
      "Customer Category": "تصنيف العميل",
      "Except these shippers": "ما عدا الشيبرز دول",
      "Except these customers": "ما عدا العملاء دول",
      "Only exclude filters are set: every order outside the excluded shippers and customers matches, which can be almost all orders.": "فلاتر الاستبعاد بس هي المتفعّلة: كل الأوردرات اللي برا الشيبرز والعملاء المستبعدين بتطابق، وده ممكن يبقى تقريباً كل الأوردرات.",
      "Exclude filters leave out the chosen shippers' and customers' orders. Check the matching count before sending.": "فلاتر الاستبعاد بتشيل أوردرات الشيبرز والعملاء اللي اخترتهم. راجع عدد الأوردرات المطابقة قبل الإرسال.",
      "Company Category": "تصنيف العميل",
      WhatsApp: "واتساب",
      "Recipient Number Type": "نوع رقم المستلم",
      "WhatsApp Group": "مجوعات الواتساب",
      "WhatsApp Logs": "سجلات الواتساب",
      Sender: "مرسل",
      "Recipient Number": "رقم المستلم",
      "Site Settings": "اعدادت الموقع",
      "System Configuration": "اعدادات النظام",
      "Pricing Setting": "اعدادات الاسعار",
      Permissions: "السماحيات",
      "R/C User Permissions": "سماحيات التحصيل والمرتجع الزمنيه",
      "User Customer Permissions": "سماحيات المسخدمين للعملاء",
      "User Shipper Permissions": "سماحيات المستخدمين للمندوبين",
      "Shipper Transfer Permissions": "سماحيات تحويل المندوبين",
      "User Evaluation Permissions": "سماحيات تقييم المستخدمين",
      "Follow up Setting": "اعدادت المتابعه",
      "Customer List": "قائمة العملاء",
      Active: "نشط",
      "New Message": "رساله جديده",
      "Add Customer": "اضافة عميل",
      "Choose Auto Collect": "اختر حاله التحصيل الاوتو",
      "Choose Auto Pickup": "اختر حاله البيكب الاوتو",
      Yes: "نعم",
      No: "لا",
      "Search Client": "البحث بالعميل",
      "Search client": "البحث بالعميل",
      "search client": "البحث بالعميل",
      "Search by username": "البحث باسم المستخدم",
      Username: "اسم المستخدم",
      "Create Pickup": "اضافه بيكب",
      "Collect Delivered": "تحصيل الموصل",
      "Return Undelivered": "ارجاع غير الموصل",
      "Shipment Info": "اتفاقيه الشحن",
      "Add Order": "أضافه أوردر",
      "Rows per page": "عدد الصفوف في الصفحه",
      "you don't have permission to Collect Order":
        "لاتملك الصلاحيه لتحصيل الاوردر",
      "you don't have permission to open Collect for this Customer":
        "لاتملك الصلاحيه لتحصيل الاوردرات لهذا العميل",
      "you don't have permission to open Return":
        "لاتملك الصلاحيه ل ارتجاع الاوردر",
      "Deleted Successfuly": "تم الحذف بنجاح",
      "Can't Delete": "لايمكن الحذف",
      "you don't have permission to add order to this customer":
        "لايمكنك اضافه اوردرات لهذا العميل",
      "you don't have permission to open revenue":
        "لايمكن فتح قائمه الربح لهذا العميل",
      "Will be send to All Customers": "سترسل الي كل عملاء",
      "Message Content": "محتوي الرسالة",
      "Broadcast footer note":
        "بيتضاف تلقائياً سطر توقيع صغير فيه التاريخ والوقت.",
      "Will be send to": "سترسل الي",
      "All Customers": "جميع العملاء",
      "Selected Customers": "عميل مختار",
      Send: "أرسال",
      Submit: "تسجيل",
      Save: "حفظ",
      Cancel: "ألغاء",
      Customer: "عميل",
      "Create Customer": "أضافه عميل",
      "Create a new Customer": "أضافه عميل جديد",
      "Full name": "ألاسم",
      "Pickup Shipper": "مندوب البيكب",
      "Email address": "الايميل الألكترونى",
      "Deel Fees": "قيمة الاتفاق",
      "Shipment Can Open": "يمكن فتح الشحنة",
      "User Name": "أسم المستخدم",
      Password: "كلمه السر",
      "Confirm Password": "تاكيد كلمة السر",
      "Mobile No": "رقم الموبيل",
      "Show Attachment": "عرض المرفق",
      "Source name": "اسم المصدر",
      "Upload Attachment": "تحميل مرفق",
      "Collect Attachment": "مرفق التحصيل",
      "Phone number is required": "رقم الهاتف مطلوب",
      "City is required": "المدينة مطلوبة",
      "Name is required": "الأسم مطلوب",
      "Username is required": "اسم المستخدم مطلوب",
      "Not Valid should have no spaces": "يجب ان لا تحتوي علي فراغات",
      "Password must have no spaces": "كلمه السر لايجب ان تحتوي علي فراغات",
      "Password is required": "كلمه السر مطلوبة",
      "Passwords must match": "يجب ان كلمه السر تكون متطابقة",
      "Customer Edit": "تعديل العميل",
      "Auto Collect Request": "طلب التحصيل الأوتو",
      "Collect Days": "أيام التحصيل",
      "Auto Pickup Request": "طلب البيكب الأوتو",
      "Pickup Days": "أيام البيكب",
      "Update Customer": "تعديل العميل",
      "Client sipment Info List": "قائمه أسعار العميل",
      "Create Client Shipment Info": "أضافه الي لقائمه أسعار العميل",
      "Edit Client Shipment Info": "تعديل قائمه اسعار العملاء",
      "Shipper Fees": "نسبة المندوب",
      "Copy Client Shipment Info": "نسخ قائمة اسعار عميل",
      "Request sent!": "تم أرسال الطلب",
      "From Company": "الشركه",
      "Invalid Customer": "عميل غير موجود",
      "Please Select Customer": "بالرجاء اختيار عميل",
      "Something went wrong!": "يوجد شئ ما خطأ",
      "Print Details": "طباعة التفاصيل",
      Search: "بحث",
      "Choose Submit Money Cashed Status": "اختر حاله استلام النقديه",
      "Full Submit": "كليا",
      "Partialy Submit": "جزئيا",
      "No Submit": "لم تسلم",
      "Total Orders": "عدد الاوردرات",
      Amount: "قيمه التحصيل",
      Fees: "قيمه الشحن",
      COD: "الصافى",
      Case: "الحاله",
      "Show Details": "عرض التفاصيل",
      "Show Detail": "عرض التفاصيل",
      // "Status Note":"ملاحظة الحاله",
      "Money Cashed": "استلام النقديه",
      "Sort By": "ترتيب حسب",
      Direction: "اتجاه الترتيب",
      Ascending: "تصاعدى",
      Descending: "تنازلى",
      Default: "افتراضى",
      of: "من",
      'Created at': 'تم الإنشاء في',
      "Updated Successfully": "تم التحديث بنجاح",
      "Operation is scheduled": "تم جدولة العملية",
      "Please select Customers": "برجاء أختيار العملاء",
      "Submit Money Cash": "أستلام النقديه",
      "Zerod Money Cash": "لم يستلم النقديه",
      "MC Details": "تفاصيل النقدية",
      "Go Money": "تحصيل نقديه",
      "one Customer only must be selected": "يجب أختيار عميل واحد فقط",
      "Select Shipper": "أختر مندوب",
      "Please Select Shipper": "برجاء أختيار مندوب",
      "Customer Revenue Detail": "تفاصيل تحصيل العميل",
      Close: "إغلاق",
      "Orders By City Report": "حميع الاوردرات مجمعه بالمدن",
      "Orders By City Details": "تفاصيل الاوردرات مجمعه بالمدن",
      "Assign Order To Shipper": "تسليم الاوردرات للمناديب",
      "Receive Returns from Shipper": "استلام المرتجعات من المناديب",
      "Delivery Returns to Customer": "تسليم المرتجعات الي العميل",
      "reset filters to be able to finalize":
        "إعادة تعيين الفلتر لتكون قادرًا على الانتهاء",

      // Collected: "تحصيل",
      Returned: "مرتجع",
      "Go to Feature": "اذهب للميزة",
      "Type": "النوع",
      "Role": "الدور",
      "What's New": "إيه الجديد؟",
      "Clear Filters": "مسح الفلاتر",
      "Previous": "السابق",
      "Next": "التالي",
      "Page": "صفحة",
      "Shipper Performance Report": "تقرير أداء المندوبين",
      "Generate Report": "إنشاء التقرير",
      "Has Problem": "به مشكلة",
      "Exclude City": "استثناء المدن",
      "Hold Reasons": "أسباب المعلق",
      "Undelivered Reasons": "أسباب عدم التوصيل",
      "Sort by Reason": "ترتيب حسب السبب",
      "None": "لا يوجد",
      "Hold Breakdown": "تفاصيل المعلق",
      "Undelivered Breakdown": "تفاصيل عدم التوصيل",
      "Reason": "السبب",
      "Percentage": "النسبة",
      "Performance Breakdown": "تفاصيل الأداء",
      "Deliv Target": "مستهدف التوصيل",
      "Out": "خارج",
      "Shippers Performance": "أداء المناديب",
      "No hold reasons recorded for this period.": "لا تتوجد أسباب معلق مسجلة لهذه الفترة.",
      "No undelivered reasons recorded for this period.": "لا توجد أسباب عدم توصيل مسجلة لهذه الفترة.",
      "No data found. Adjust filters and click \"Generate Report\".": "لم يتم العثور على بيانات. اضبط الفلاتر واضغط على \"إنشاء التقرير\".",
      "Hold: ": "معلق: ",
      "Undelivered: ": "عدم توصيل: ",
      "Total Shippers Worked": "إجمالي المندوبين العاملين",
      "Date Range": "الفترة الزمنية",
      "to": "إلى",
      "Performance Problem Detected": "تم اكتشاف مشكلة في الأداء",
      "Shipper Name": "اسم المندوب",
      "Order Delivery Status Audit": "سجل مراجعة حالات تسليم الطلبات",
      "Old Status": "الحالة القديمة",
      "New Status": "الحالة الجديدة",
      "Transaction Date": "تاريخ الحركة",
      "State Date": "تاريخ الحالة",
      "Shipper Performance Permissions": "صلاحيات تقارير أداء المندوبين",
      "Select User": "اختر المستخدم",
      "Shipper ID": "رقم المندوب",
      "Phone Number": "رقم الهاتف",
      "Save Changes": "حفظ التغييرات",
      "Permissions saved successfully": "تم حفظ الصلاحيات بنجاح",
      "Please select a user first": "برجاء اختيار مستخدم أولا",
      "Available Shippers": "المناديب المتاحين",
      "Selected Shippers": "المناديب المختارين",
      "Search...": "بحث...",
      "Filter selections...": "تصفية المختارين...",
      "No shippers selected yet": "لم يتم اختيار مناديب بعد",
      "Click checkboxes on the left to add shippers": "اضغط على مربعات الاختيار على اليسار لإضافة مناديب",
      "shippers will be assigned to": "سيتم تعيين مناديب إلى",
      "Select user to manage their shipper report permissions": "اختر المستخدم لإدارة صلاحيات تقرير المناديب",
      "No shippers found": "لم يتم العثور على مناديب",
      "ID": "المعرف",
      "Recipient Delivery Score": "تقييم تسليمات المستلم",
      "Send feedback": "إرسال تقييم",
      "Purpose": "الغرض",
      "Not used": "غير مستخدم",
      "No feedback templates yet. Open WhatsApp templates and set a template's Purpose to Feedback.": "مافيش قوالب تقييم لسه. افتح قوالب الواتساب وغيّر غرض أي قالب لـ تقييم.",
      "No active templates. Add one under WhatsApp templates.": "مافيش قوالب مفعّلة. ضيف قالب من قوالب الواتساب.",
      "Hold follow-up": "متابعة تعليق",
      "Feedback": "تقييم",
      "Feedback templates are never auto-routed and ignore hold reasons.": "قوالب التقييم مابتتوجهش تلقائيًا وبتتجاهل أسباب التعليق.",
      "Send feedback to all matching": "إرسال تقييم لكل المطابق",
      "Choose a template": "اختر قالب",
      "Every selected order is sent the same feedback template, whatever its hold reason.": "كل الأوردرات المختارة هتستلم نفس قالب التقييم، مهما كان سبب التعليق.",
      "Every selected order is sent the same template. Orders whose hold reason the template does not cover are skipped — the preview lists them.": "كل الأوردرات المختارة هتستلم نفس القالب. الأوردرات اللي سبب تعليقها مش مغطى في القالب بتتخطى — المعاينة بتعرضها.",
      "Based on {{count}} completed order(s) only": "مبني على {{count}} طلب منتهي فقط",
      "Could not load the delivery score for this number.": "تعذر تحميل تقييم التسليم للرقم ده",
      "No valid Egyptian mobile number in this order, so no delivery score can be shown.": "مافيش رقم موبايل مصري صالح في الأوردر ده، فمش هينفع نعرض تقييم تسليم",
      "Not a valid Egyptian mobile number, so it has no delivery score.": "مش رقم موبايل مصري صالح، فمالوش تقييم تسليم",
      "primary": "الأساسي",
      "Total orders": "إجمالي الطلبات",
      "Still in progress": "قيد التنفيذ",
      "Cancelled and returned": "الإلغاءات والمرتجعات",
      "Delivery rate": "نسبة التسليم",
      "Cancellation rate": "نسبة الإلغاء",
      "High delivery rate": "نسبة التسليمات مرتفعة",
      "Average delivery rate": "نسبة التسليمات متوسطة",
      "Low delivery rate": "نسبة التسليمات منخفضة",
      "Not enough data": "بيانات غير كافية",
      "Your orders with this number": "طلباتك على الرقم ده",
      "delivered": "تم تسليمها",
      "total": "إجمالي",
      "Order": "الأوردر",
      "Company": "الشركة",
      "Delivered": "تم التسليم",

      // منفصلة عن مفردات تسليم الشحنة: "تم التسليم" معناها الشحنة مش الرسالة.
      "wa.status.read": "اتقريت",
      "wa.status.delivered": "وصلت للموبايل",
      "wa.status.accepted": "واتساب استلمها",
      "wa.status.queued": "في الانتظار",
      "wa.status.sending": "بيتبعت",
      "wa.status.failed": "فشلت",
      "wa.status.cancelled": "اتلغت",
      "wa.status.unknown": "غير معروف",
      "wa.queued": "في الانتظار",
      "wa.accepted": "واتساب استلمها",
      "wa.delivered": "وصلت للموبايل",
      "wa.failed": "فشلت",
      "wa.awaiting": "في انتظار الرد",
      "wa.queueDrained": "الطابور خلص",
      "wa.acceptedAt": "واتساب استلمها في",
      "wa.deliveredAt": "وصلت للموبايل في",
      "wa.readAt": "اتقريت في",
      "wa.failedAt": "فشلت في",
      "wa.alerts.title": "تنبيهات فشل التسليم",
      "wa.alerts.sub": "إيميل لما رسايل واتساب استلمها ترجع تتبلغ إنها ماوصلتش.",
      "wa.alerts.emails": "مستقبلو التنبيه",
      "wa.alerts.emailsHelp": "افصل بينهم بفاصلة أو سطر جديد. سيبها فاضية عشان يتسجل الفشل في اللوج بس.",
      "wa.alerts.threshold": "عدد حالات الفشل قبل التنبيه",
      "wa.alerts.thresholdHelp": "بتتحسب كل فحص (10 دقايق).",
      "wa.alerts.cooldown": "فترة الهدوء (دقايق)",
      "wa.alerts.cooldownHelp": "مدة السكوت بعد إرسال تنبيه.",
      "wa.alerts.smtpNote": "محتاج إعداد SMTP على السيرفر. للتأكد: manage.py check_delivery_alerts",
      "wa.alerts.invalid": "إيميل غير صحيح",
      "Unsaved changes": "تغييرات مش متسجلة",
      "All changes saved": "كل التغييرات اتسجلت",
      "Phone start with": "الموبايل يبدأ بـ",
      "* Note: Phone searches without using the \"Phone start with\" filter or specifying a date range are limited to orders from the last 90 days.":
        "* ملحوظة: البحث بالموبايل من غير فلتر \"الموبايل يبدأ بـ\" أو من غير تحديد فترة بيجيب أوردرات آخر 90 يوم بس.",
      "Header font size": "حجم خط عناوين الجدول",
      "Row font size": "حجم خط صفوف الجدول",
      "Title font size": "حجم خط العنوان",
      "Acknowledgement font size": "حجم خط الإقرار",
      "Totals table font size": "حجم خط جدول الإجماليات",
      Copies: "عدد النسخ",
      "Double Page Print": "طباعة على صفحتين",
      Set: "تعيين",
      "Font sizes (px)": "أحجام الخط (بكسل)",
      "Default: {{size}} px": "الافتراضي: {{size}} بكسل",
      "{{min}}–{{max}} px. Leave empty for the default size.": "من {{min}} لـ {{max}} بكسل. سيبه فاضي للحجم الافتراضي.",
      "Check & Fix Duplicate Prices": "فحص ومعالجة الأسعار المكررة",
      "Resolve Duplicate Prices for Category": "معالجة الأسعار المكررة للفئة ({{category}})",
      "Shipment prices": "أسعار الشحن",
      "Return prices": "أسعار المرتجع",
      "Duplicate return prices explanation": "السعر بيبقى متكرر لما نفس العميل ونفس حالة المرتجع ونفس المدينة يتكرروا في أكتر من صف. السيستم بيحتفظ بآخر صف اتعدل (أو أعلى رقم)، ويشيل المدينة من الصفوف الأقدم، ويمسح الصفوف اللي مبقاش فيها مدن، وكل ده بيتسجل في سجلات التدقيق.",
      "Duplicate return prices summary alert": "لقينا {{groups}} مجموعة متكررة: المدينة هتتشال من {{rows}} صف أقدم، و{{deleted}} صف هيتمسح لأنه مش هيبقى فيه مدن.",
      "Return status": "حالة المرتجع",
      "Removed fees": "الأسعار اللي هتتشال",
      "I understand that the city will be removed from older duplicate return-price rows": "فاهم إن المدينة هتتشال من صفوف أسعار المرتجع الأقدم المتكررة.",
      "No duplicate return price rows found": "مفيش صفوف أسعار مرتجع متكررة",
      "Some customers have duplicate return-price rows for the selected cities.": "فيه عملاء عندهم صفوف أسعار مرتجع متكررة للمدن اللي اخترتها.",
      "Add to existing row": "إضافة لصف موجود",
      "return_city_copy_description": "إضافة المدينة الجديدة لأسعار مرتجعات العملاء من غير ما أي سعر يتغير. لو اخترت مدينة مصدر، المدينة بتتضاف لكل صف فيه مدينة المصدر؛ ولو مخترتش، بتتضاف لأحدث صف في كل حالة. الحالات اللي فيها المدينة الجديدة أصلاً بتتخطى.",
      "Source city (optional)": "مدينة المصدر (اختياري)",
      "{{newCity}} is added to {{rows}}, fees unchanged": "{{newCity}} هتتضاف لـ {{rows}}، والأسعار زي ما هي",
      "rows holding {{city}}": "الصفوف اللي فيها {{city}}",
      "the newest row of each status": "أحدث صف في كل حالة",
      "Skipped — no return prices": "تم التخطي — مفيش أسعار مرتجع",
      "Row that gets the city": "الصف اللي هتتضاف له المدينة",
      Price: "السعر",
      Updated: "آخر تحديث",
      "Apply to {{count}} return prices": "تطبيق على {{count}} سعر مرتجع",
      "Customers affected: {{count}}.": "العملاء المتأثرين: {{count}}.",
      "Showing the first {{shown}} of {{total}}. Fix covers all of them.": "معروض أول {{shown}} من {{total}}. الإصلاح بيشمل الكل.",
      "Active rules run daily and permanently delete every matching order older than the set number of days. Orders with financial records, or that were collected or returned, are skipped. Material request orders are never deleted.": "القواعد المفعّلة بتشتغل يومياً وبتحذف نهائياً كل طلب مطابق أقدم من عدد الأيام المحدد. الطلبات اللي عليها قيود مالية أو اتحصّلت أو اترجعت بيتم تخطيها. طلبات طلب المواد عمرها ما بتتحذف.",
      "Always protected": "محمية دائماً",
      "Always protected: these orders are in a shipper's cash hand-over that is still pending, or have a material request (deleting the order would delete it).": "محمية دائماً: الطلبات دي في طلب تقفيل لمندوب لسه معلق، أو عليها طلب مواد (حذف الطلب هيحذف طلب المواد).",
      "Collected (customer)": "تم التحصيل (العميل)",
      "Collected by shipper": "تم التحصيل من المندوب",
      "Completed": "مكتمل",
      "Counting matching orders, this can take a while…": "جاري حساب الطلبات المطابقة، ممكن ياخد وقت…",
      "Customer revenue": "إيرادات العميل",
      "Deleted": "تم الحذف",
      "Deleted by cleanup run #{{id}}": "محذوف بواسطة تشغيل التنظيف رقم {{id}}",
      "Disable protection": "إيقاف الحماية",
      "Discard": "تجاهل التعديلات",
      "Enable": "تفعيل",
      "Enable cleanup rule": "تفعيل قاعدة التنظيف",
      "Error": "خطأ",
      "Failed": "فشل",
      "Financial records": "السجلات المالية",
      "Finished": "انتهى",
      "Hide protections": "إخفاء الحمايات",
      "Interrupted": "انقطع",
      "Label": "الاسم",
      "Last run": "آخر تشغيل",
      "Matched": "مطابق",
      "Matching orders will be permanently deleted every day. This cannot be undone.": "الطلبات المطابقة هتتحذف نهائياً كل يوم. الإجراء ده لا يمكن التراجع عنه.",
      "Material request": "طلب مواد",
      "Never run": "لم يتم التشغيل بعد",
      "Nothing matches today; future matches will be deleted daily.": "مفيش طلبات مطابقة النهارده؛ أي طلبات تطابق بعد كده هتتحذف يومياً.",
      "Older than (days)": "أقدم من (أيام)",
      "Older than (days) must be at least 1": "أقدم من (أيام) لازم تكون 1 على الأقل",
      "Order Cleanup Rules": "قواعد تنظيف الطلبات",
      "Pending closing request": "طلب تقفيل معلق",
      "Protected — read only ({{skipped_count}})": "محمية — للعرض فقط ({{skipped_count}})",
      "Protections": "الحمايات",
      "Protections disabled": "حمايات متوقفة",
      "Protections off": "الحمايات متوقفة",
      "Reasons": "الأسباب",
      "Retry": "إعادة المحاولة",
      "Return requests": "طلبات المرتجع",
      "Returned by shipper": "مرتجع من المندوب",
      "Returned to client": "مرتجع للعميل",
      "Rule {{name}} has not run in over {{hours}} hours; the daily job may not be running.": "القاعدة {{name}} ماشتغلتش من أكتر من {{hours}} ساعة؛ ممكن المهمة اليومية تكون مش شغالة.",
      "Rule {{name}} is active with protections disabled: {{labels}}": "القاعدة {{name}} مفعّلة والحمايات دي متوقفة: {{labels}}",
      "Rule {{name}} last run {{status}}: {{error}}": "آخر تشغيل للقاعدة {{name}}: {{status}} - {{error}}",
      "Rule {{name}} was skipped: {{reason}}": "تم تخطي القاعدة {{name}}: {{reason}}",
      "Run history": "سجل التشغيل",
      "Running": "قيد التشغيل",
      "Save changes before enabling": "احفظ التعديلات قبل التفعيل",
      "Preview changes": "معاينة التعديلات",
      "Preview of your unsaved changes. Nothing is saved; save the rule to use them.": "دي معاينة لتعديلاتك اللي لسه متحفظتش. مفيش حاجة اتحفظت؛ احفظ القاعدة عشان تتطبق.",
      "Saved": "تم الحفظ",
      "Set and save a filter before changing protections": "حدد فلتر واحفظه قبل تعديل الحمايات",
      "Shipper revenue": "إيرادات المندوب",
      "Started": "بدأ",
      "Status flags": "علامات الحالة",
      "Stopped": "متوقف",
      "View deleted orders": "عرض الطلبات المحذوفة",
      "Will be deleted ({{count}})": "سيتم حذفها ({{count}})",
      "You do not have access to this page.": "ليس لديك صلاحية للوصول لهذه الصفحة.",
      "protects {{count}} matched orders": "بتحمي {{count}} طلب مطابق",
      "protects {{count}} matched orders ({{uncovered}} not covered by status flags)": "بيحمي {{count}} طلب مطابق ({{uncovered}} مش متغطيين بحالات الطلب)",
      "{{count}} audit log rows failed to write": "فشل تسجيل {{count}} من سجلات المراجعة",
      "{{count}} orders will become deletable even though they are marked {{label}}. Deleted orders cannot be restored.": "{{count}} طلب هيبقى قابل للحذف رغم إنه متعلّم {{label}}. الطلبات المحذوفة مش هينفع ترجع.",
      "{{count}} orders will become deletable. Their related {{label}} records are deleted with them and cannot be restored.": "{{count}} طلب هيبقى قابل للحذف. سجلات {{label}} المرتبطة بيهم هتتحذف معاهم ومش هينفع ترجع.",
      "{{label}} protects {{count}} matched orders.": "{{label}} بتحمي {{count}} طلب مطابق.",
      "Copy": "نسخ",
      "Copied": "تم النسخ",
      "Follow-up user": "مسؤول المتابعة",
      "Order Month Export": "تصدير طلبات شهر",
      "Exports every order of the chosen month, with no row limit. Files are deleted after 7 days.": "بيصدّر كل طلبات الشهر المختار من غير حد لعدد الصفوف. الملفات بتتمسح بعد 7 أيام.",
      "Month": "الشهر",
      "Year": "السنة",
      "Done": "جاهز",
      "Requested by": "طلبه",
      "Requested at": "وقت الطلب",
      "Finished at": "وقت الانتهاء",
      "No exports yet": "مفيش ملفات لسه",
      "Export started, it will appear here when ready": "بدأ التصدير، الملف هيظهر هنا لما يجهز",
      "Failed to load exports": "فشل تحميل ملفات التصدير",
      "Failed to start export": "فشل بدء التصدير",
      "Failed to delete export": "فشل حذف ملف التصدير",
      "Failed to download export": "فشل تنزيل ملف التصدير",
      "Saving file…": "جاري حفظ الملف…",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  // Every key here is a flat string and many contain "." or ":" — English
  // prose, or a "wa.status.read" namespace. Left on, i18next reads those as
  // paths into nested objects, finds nothing, and echoes the key back: 42
  // Arabic strings silently never translated.
  keySeparator: false,
  nsSeparator: false,
  interpolation: {
    escapeValue: false,
  },
});
